var Alabama = "阿拉巴馬州";
var Alaska = "阿拉斯加州";
var Arizona = "亞利桑那州";
var Arkansas = "阿肯色州";
var California = "加利福尼亞州";
var Colorado = "科羅拉多州";
var Connecticut = "康乃狄克州";
var Delaware = "德拉瓦州";
var Florida = "佛羅里達州";
var Georgia = "喬治亞州";
var Hawaii = "夏威夷州";
var Idaho = "愛達荷州";
var Illinois = "伊利諾州";
var Indiana = "印第安那州";
var Iowa = "愛荷華州";
var Kansas = "堪薩斯州";
var Kentucky = "肯塔基州";
var Louisiana = "路易斯安那州";
var Maine = "緬因州";
var Maryland = "馬里蘭州";
var Massachusetts = "麻薩諸塞州";
var Michigan = "密西根州";
var Minnesota = "明尼蘇達州";
var Mississippi = "密西西比州";
var Missouri = "密蘇里州";
var Montana = "蒙大拿州";
var Nebraska = "內布拉斯加州";
var Nevada = "內華達州";
var Ohio = "俄亥俄州";
var Oklahoma = "奧克拉荷馬州";
var Oregon = "奧勒岡州";
var Pennsylvania = "賓州";
var Tennessee = "田納西州";
var Texas = "德克薩斯州";
var Utah = "猶他州";
var Vermont = "佛蒙特州";
var Virginia = "維吉尼亞州";
var Washington = "華盛頓州";
var Wisconsin = "威斯康辛州";
var Wyoming = "懷俄明州";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "華盛頓哥倫比亞特區 (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "新罕布夏州",
	"New Jersey": "紐澤西州",
	"New Mexico": "新墨西哥州",
	"New York": "紐約州",
	"North Carolina": "北卡羅萊納州",
	"North Dakota": "北達科他州",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "羅德島州",
	"South Carolina": "南卡羅來納州",
	"South Dakota": "南達科他州",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "西維吉尼亞州",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
